import React, { useEffect } from 'react';
import { Grid } from 'semantic-ui-react';

import GridColumnInputWrapper from '../../../../common/GridColumnInputWrapper';
import { AccordionWrapper, InputWrapper } from 'react-lib/dist/components-es';
import CommonTagsInputWrapper from '../../../../common/CommonTagsInputWrapper';
import ExternalDocumentTagsUrlInputWrapper from '../../../../common/ExternalDocumentTagsUrlInputWrapper';
import { equipmentsActions } from '../../../../../behavior/equipments';
import { connect } from 'react-redux';

type Props = {
  equipmentLevList: any[];
  values: any;
  disabled: boolean;
  setFieldValue: (arg1: string, arg2: string) => void;
  errors: any;
};

type CheckboxTagsInputRowProps = {
  checkboxPropName: string;
  checkBoxLabel: string;
  tagsPropName: string;
  tagsInputPlaceholder: string;
  isExternalDocumentTagUrl: boolean;
  matchProperty?: string;
  displayProps?: string;
};

const IPPMInformationContainer = ({
  equipmentLevList,
  setFieldValue,
  values,
  disabled,
  errors,
}: Props) => {
  const onChangeClearRef = (ref: string) => {
    setFieldValue('chemicalRiskAttributes.' + ref, '');
  };

  const getCheckboxTagsInputRow = ({
    checkboxPropName,
    checkBoxLabel,
    tagsPropName,
    tagsInputPlaceholder,
    isExternalDocumentTagUrl,
    matchProperty = '',
    displayProps = '',
  }: CheckboxTagsInputRowProps) => {
    return (
      <>
        <GridColumnInputWrapper
          fieldClassName="checkboxInline checkboxMargin"
          inputClassName="left-floated"
          displayLabelAfter={true}
          labelClassName="checkboxLabelOnRight"
          value={values.chemicalRiskAttributes[checkboxPropName] || false}
          name={'chemicalRiskAttributes.' + checkboxPropName}
          label={checkBoxLabel}
          type="checkbox"
          disabled={disabled}
          onChange={() => onChangeClearRef(tagsPropName)}
          render={(props: any) => <InputWrapper {...props} />}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
        />
        <GridColumnInputWrapper
          name={'chemicalRiskAttributes.' + tagsPropName}
          disabled={disabled || !values.chemicalRiskAttributes[checkboxPropName]}
          placeholder={tagsInputPlaceholder}
          value={values.chemicalRiskAttributes[tagsPropName]}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          render={(props: any) => {
            if (isExternalDocumentTagUrl) {
              return <ExternalDocumentTagsUrlInputWrapper maxTags={1} {...props} />;
            } else {
              return (
                <CommonTagsInputWrapper
                  {...props}
                  maxTags={1}
                  dynamicSuggestionListAction={(v: string) =>
                    equipmentsActions.getEquipmentLevAutocompleteList(v)
                  }
                  customFilteredSuggestions={equipmentLevList}
                  matchProperty={matchProperty}
                  displayProps={displayProps}
                  value={values.chemicalRiskAttributes.ppmLev}
                />
              );
            }
          }}
        />
      </>
    );
  };

  const getContainerContent = () => {
    return (
      <Grid stackable columns={2} verticalAlign="top">
        <GridColumnInputWrapper
          width="16"
          fieldClassName="checkboxInline checkboxMargin"
          inputClassName="left-floated"
          displayLabelAfter={true}
          labelClassName="checkboxLabelOnRight"
          value={values.chemicalRiskAttributes.ppmIsGeneralVentilationRequired}
          name="chemicalRiskAttributes.ppmIsGeneralVentilationRequired"
          label="inventory.details.page.ppm.inf.container.is.general.ventilation.required"
          type="checkbox"
          disabled={disabled}
          values={values}
          setFieldValue={setFieldValue}
          errors={errors}
          render={(props: any) => <InputWrapper {...props} />}
        />
        {getCheckboxTagsInputRow({
          checkboxPropName: 'ppmIsLevRequired',
          checkBoxLabel: 'inventory.details.page.ppm.inf.container.is.lev.required',
          tagsPropName: 'ppmLev',
          tagsInputPlaceholder: 'specify.lev.placeholder',
          isExternalDocumentTagUrl: false,
          matchProperty: 'equipmentCode',
          displayProps: 'equipmentCode,equipmentdesc',
        })}
        {getCheckboxTagsInputRow({
          checkboxPropName: 'ppmIsWorkInstrProcRequired',
          checkBoxLabel: 'inventory.details.page.ppm.inf.container.is.work.instr.proc.required',
          tagsPropName: 'ppmWorkInstrRef',
          tagsInputPlaceholder: 'give.ref.edms.no.placeholder',
          isExternalDocumentTagUrl: true,
        })}
        {getCheckboxTagsInputRow({
          checkboxPropName: 'ppmIsOtherRequired',
          checkBoxLabel: 'inventory.details.page.ppm.inf.container.is.other.required',
          tagsPropName: 'ppmOtherRef',
          tagsInputPlaceholder: 'inventory.details.page.ppm.inf.container.other.edms.placeholder',
          isExternalDocumentTagUrl: true,
        })}
      </Grid>
    );
  };

  return (
    <AccordionWrapper
      accordionTitle="inventory.details.page.ppm.inf.container.title"
      className="containerReducedWhiteSpace"
      render={getContainerContent}
    />
  );
};

const mapStateToProps = (state: any) => ({
  equipmentLevList: state.equipments.equipmentLevList,
});

const mapDispatchToProps = (dispatch: any) => ({
  getEquipmentLevList: () => dispatch(equipmentsActions.getEquipmentLevAutocompleteList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(IPPMInformationContainer);
